<template>
  <div class="row q-py-sm text-white">
    <snap-photo />
    <div class="col-xs-10 q-pa-sm">
      <q-file
        v-model="documentos_adjuntos"
        label="Documentos adjuntos"
        use-chips
        multiple
        append
        outlined
        dense
        label-color="grey"
        dark
      />
    </div>
    <div class="col-xs-2 q-pa-sm text-center">
      <q-btn
        class="bg-pragma"
        round
        icon="add_a_photo"
        @click="capturarImagen()"
      ></q-btn>
    </div>
    <div class="col-xs-12 q-pa-sm text-center">
      <q-btn
        color="positive"
        rounded
        icon="save"
        @click="guardarDocumentos()"
        label="Guardar documentos"
        v-if="documentos_adjuntos.length > 0"
        :loading="loading"
      ></q-btn>
    </div>
    <div class="col-xs-12 q-pa-sm text-center">
      Documentos guardados
    </div>
    <div class="col-xs-12">
      <q-list>
        <q-item
          clickable
          v-ripple
          v-for="documento in documentos"
          :key="documento.id"
          @click="verDocumento(documento)"
        >
          <q-card style="width: 100%" class="text-caption">
            <q-card-section class="bg-grey-9 text-white">
              <div class="row full-width">
                <div class="col-xs-2">
                  <q-icon name="attach_file" size="sm"></q-icon>
                </div>
                <div class="col-xs-10 wrap">
                  <span style="word-break: break-all">{{documento.direccion}}</span>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </q-item>
      </q-list>
    </div>
  </div>
</template>

<script>
import { inject, ref } from 'vue'
import env from '../../../../config/env'
import SnapPhoto from '../../../components/SnapPhoto.vue'
import axios from 'axios'
import { useQuasar } from 'quasar'

export default {
  components: {
    SnapPhoto
  },
  props: ['documentos', 'solicitud'],
  setup (props) {
    // Variables del componente
    const bus = inject('bus')
    const $q = useQuasar()

    const documentos_adjuntos = ref([])
    const loading = ref(false)

    // Métodos y funciones
    const verDocumento = (documento) => {
      let url_file = `${env.SERVER_URL}empresas/${documento.empresa_slug}/${documento.gestion}/rendicion/${documento.direccion}`
      bus.emit('openDialogViewFile', url_file)
    }

    const capturarImagen = () => {
      bus.emit('openDialogSnapPhoto')
    }

    const guardarDocumentos = async () => {
      try {
        loading.value = true
        // Procesamiento de archivos para la petición
        let formData = new FormData()
        let count = 1
        documentos_adjuntos.value.forEach(item => {
          count++
          formData.append(`doc${count}`, item)
        })
        formData.append('solicitud_id', props.solicitud.id)
        await axios.post('solicitud-documentos/rendicion/guardar', formData)
        $q.notify({
          message: 'Archivos guardados',
          color: 'positive'
        })
        bus.emit('refreshRendicion')
        loading.value = false
        documentos_adjuntos.value = []
      } catch (error) {
        console.log(error)
        loading.value = false
      }
    }

    // Creación del componente
    bus.on('closeDialogSnapPhoto', (image) => {
      var file = new File([image], `${Math.floor(Math.random() * 10000)}.jpg`)
      documentos_adjuntos.value.push(file)
    })

    // Variables del template
    return {
      verDocumento,
      documentos_adjuntos,
      capturarImagen,
      guardarDocumentos,
      loading
    }
  }
}
</script>

<style>

</style>